import scrollTo from 'animated-scroll-to'
import { MuiCheckbox } from '@/admin/components/mui-checkbox'
import { useAppContext } from '@/pages/_app'
import { windowStorage } from '@/utils/env'
import { Venue } from '@root/../shared/src/types/api'
import { Trans } from 'react-i18next'
import { useCheckbox } from './checkbox'

export type PersonalDataConsentProps = {
  venue: Venue
}

export function PersonalDataConsent(props: PersonalDataConsentProps) {
  const { t } = useAppContext()
  const checkbox = useCheckbox({
    id: 'personalDataConsent',
    label: (
      <Trans
        t={t}
        i18nKey="personalDataConsent:confirm"
        values={{ venueTitle: props.venue.title }}
        components={{
          termsLink: <a className="underline" href={`/venue/${props.venue.name}/terms`} />,
        }}
      />
    ),
    // label: t('personalDataConsent:confirm', { venueTitle: props.venueTitle }),
    storage: windowStorage,
    startingValue: false,
    disabled: false,
  })
  return (
    <div className="mt-8 text-opaque dark:text-opaqueDark text-sm personal-consent-wrapper">
      <MuiCheckbox {...checkbox.props} checkboxProps={{ sx: { mb: 'auto', mt: -1 } }} />
    </div>
  )
}

export function checkPersonalDataConsent() {
  const userConsentedJson = windowStorage.getItem('uiState/checkbox/personalDataConsent')
  const userConsented = userConsentedJson !== null ? JSON.parse(userConsentedJson) : null

  if (userConsented === false) {
    window.alert('Согласитесь на обработку персональных данных поставив галочку')
    const element = document.querySelector('.personal-consent-wrapper')
    if (element) {
      scrollTo(element, {
        verticalOffset: -100,
      })
    }
    return false
  }

  return true
}
